/* =============================================================================
   FTB STICKY ATC — Intersection Observer, zero library
   Slides in from bottom when main ATC button scrolls out of view
   ============================================================================= */

(function () {
  'use strict';

  var stickyBar = document.getElementById('ftb-sticky-atc');
  var mainAtcRow = document.getElementById('ftb-atc-row');

  if (!stickyBar || !mainAtcRow) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -20px 0px' }
  );

  observer.observe(mainAtcRow);
})();
